import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full p-2" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-gray-800" }, "Mensaje", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4" }, null, -1)
const _hoisted_5 = { class: "flex flex-row gap-4 justify-start w-full items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, " El archivo debe ser un formato .zip, donde los archivos comprimidos deben seguir un patrón de nombre siguiendo este ejemplo IDA_IDB_nombreArchivo.png. Donde IDA e ID B on las id's del accionista. ", -1)
const _hoisted_7 = { class: "flex flex-row items-center gap-4" }
const _hoisted_8 = ["disabled"]

import { computed, ref } from "vue";
import { storeToRefs } from "pinia";

import useNotificationStore from "@/stores/notification";

import NewModal from "../atoms/NewModal.vue";
import Switch from "../atoms/Switch.vue";
import TextField from "../atoms/TextField.vue";
import MessageUserSelector from "../molecules/MessageUserSelector.vue";
import Swal from "sweetalert2";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadMessageFileModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  id: {
    type: Number,
    default: 0,
  },
},
  emits: ["update:visible"],
  setup(__props, { emit }) {

const props = __props;





const notificationStore = useNotificationStore();

const { createBulkLoadResponse, bulkLoadForm } = storeToRefs(notificationStore);

const handleBulkLoad = async () => {
  await notificationStore.createBulkLoad();

  if (createBulkLoadResponse?.value?.success) {
    emit("update:visible");
    Swal.fire("¡Listo!", "Carga enviado exitosamente!.", "success");
  } else {
    Swal.fire("Error", "Oops, hubo un error", "error");
  }
};

const handleFiles = async (event: Event) => {
  if (event.target) {
    bulkLoadForm.value.thumbnail = event.target?.files[0];
  }
};

const disableSubmit = computed(
  () =>
    bulkLoadForm.value.subject &&
    bulkLoadForm.value.description &&
    bulkLoadForm.value.thumbnail
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NewModal, {
      title: "Carga masiva",
      visible: __props.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = (e) => _ctx.$emit('update:visible', e))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = () => _ctx.$emit('update:visible')),
            type: "button",
            class: "flex flex-row items-center rounded-full px-4 py-2 bg-gray-400 transition text-sm shadow text-white"
          }, " Cancelar "),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (handleBulkLoad())),
            disabled: !disableSubmit.value,
            class: "flex flex-row items-center rounded-full px-4 py-2 bg-green-700 text-sm shadow text-white disabled:bg-gray-500 transition-all"
          }, " Enviar ", 8, _hoisted_8)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextField, {
            type: "text",
            name: "subject",
            label: "Asunto",
            placeholder: "Ingrese asunto",
            model: _unref(bulkLoadForm).subject,
            "onUpdate:model": _cache[0] || (_cache[0] = 
            (value) => {
              if (_unref(bulkLoadForm)) _unref(bulkLoadForm).subject = value ?? '';
            }
          )
          }, null, 8, ["model"]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bulkLoadForm).description) = $event)),
              placeholder: "Ingrese mensaje",
              class: "border border-gray-300 rounded-md p-2"
            }, "\n          ", 512), [
              [_vModelText, _unref(bulkLoadForm).description]
            ])
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              class: "file:rounded-full file:bg-green-700 file:text-sm file:font-sm file:px-4 file:py-2 file:text-white file:border-0 file:shadow-lg file:my-4",
              accept: ".zip",
              onChange: _cache[2] || (_cache[2] = (event) => handleFiles(event)),
              type: "file"
            }, null, 32)
          ]),
          _hoisted_6
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})